import React, { useEffect, useMemo } from "react";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import classNames from "classnames";

import { useSubscriptionsContext } from "@/contexts/subscriptions";
import SubsReadTopPanel from "@/components/subscriptions/SubsReadTopPanel";
import { validateDate } from "@/shared/utils/subscriptions";
import SubsReadViewElement from "./SubsReadViewElement";
import { makeChapterUrl } from "../../utils/routes/routes";
import { withLogin } from "@/hocs/withLogin";

import styles from "./subscriptions.module.scss";
import { URLS } from "@/shared/utils/url/url";

const SubscriptionsRead = () => {
  const { t } = useTranslation();
  const { fetchContent, content, date } = useSubscriptionsContext();
  const router = useRouter();

  const [path, , bookId] = router.query.subscription;

  useEffect(() => {
    if (!content.length) {
      fetchContent();
    }
  }, [content, fetchContent]);

  const currentContent = content[date] || [];
  const bookIndex = currentContent.findIndex((item) => item.book_id === parseInt(bookId, 10));
  const index = bookIndex === -1 ? 0 : bookIndex;
  const currentSub = currentContent[index];

  const readContent = useMemo(() => {
    if (!currentSub) {
      return [];
    }

    const readContent = currentSub.content.map((item, index) => ({
      id: index,
      content: item,
      "element_type": "p"
    }));

    readContent.unshift({
      id: "head",
      content: currentSub.book_title,
      className: currentSub.book_type,
      "element_type": "h2"
    });

    return readContent;
  }, [currentSub]);

  const onDateChange = (newDate) => {
    router.push(`${URLS.subscription}/${path}/${validateDate(newDate)}/${bookId}`);
  };

  const openReaderHandler = () => {
    router.push(makeChapterUrl(currentSub?.start_para_id));
  };

  return (
    <div className={styles["subs-reader-wrap"]}>
      <SubsReadTopPanel
        currentSub={currentSub}
        subscriptionContent={currentContent}
        currentIndex={index}
        onDateChange={onDateChange}
        openReaderHandler={openReaderHandler}
      />
      {readContent.length ? (
        <div className={classNames(styles["subscription-read-view"])}>
          {readContent.map((item) => (
            <SubsReadViewElement
              item={item}
              key={`${item.id}-${item.element_type}`}
              bookType={currentSub.book_type}
            />
          ))}
        </div>
      ) : (
        <div className={styles["text-no-subscriptions"]}>{t("noSubsToRead")}</div>
      )}
    </div>
  );
};

export default withLogin(SubscriptionsRead);
